export function toUnixTimestamp(value: string): number {
  return parseInt((new Date(value).getTime() / 1000).toFixed(0), 10);
}

// format date to DD-MM-YYYY
export function toShortDate(value: string): string {
  const date = new Date(value);
  return (
    ('0' + date.getDate()).slice(-2) +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    date.getFullYear()
  );
}
